module.exports = __webpack_public_path__ + "static/media/solo-card-5-points.a66b94f6.png";